export enum ScheduleType {
  Default,
  Override
}
